// extracted by mini-css-extract-plugin
export default {"childrenContainer":"VEyxAVQKtQ8TfZ6tTs3T"};